/**
 * <cart-shipping-insurance> — a checkbox that adds/removes the "Shipping
 * Insurance" product (handle: shipping-insurance) as a cart line item, then
 * asks the cart drawer to refresh its totals.
 *
 * Note: adding uses /cart/add.js and removing uses /cart/change.js — the
 * Cart AJAX API's /cart/change.js can only adjust a line that's already in
 * the cart, it silently no-ops if asked to add a variant that isn't there
 * yet, so a single endpoint can't handle both directions.
 */
if (!customElements.get('cart-shipping-insurance')) {
  class CartShippingInsurance extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (!this.checkbox) return;

      this.changeHandler = this.handleChange.bind(this);
      this.checkbox.addEventListener('change', this.changeHandler);
    }

    disconnectedCallback() {
      if (this.checkbox) this.checkbox.removeEventListener('change', this.changeHandler);
    }

    async handleChange(evt) {
      const checked = evt.target.checked;
      const variantId = this.dataset.variantId;
      this.checkbox.disabled = true;

      try {
        const response = checked
          ? await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }]
              })
            })
          : await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: 0
              })
            });

        if (!response.ok) throw new Error('Could not update shipping insurance');
      } catch (error) {
        evt.target.checked = !checked; // revert the checkbox on failure
        console.log(error); // eslint-disable-line
      } finally {
        this.checkbox.disabled = false;
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      }
    }
  }

  customElements.define('cart-shipping-insurance', CartShippingInsurance);
}
